<label class="control">
  @if (label()) {
    <span class="control__label">{{ label() }}</span>
  }

  <span class="control__input">
    <textarea
      class="control__input_controller"
      [attr.data-style]="style()"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [rows]="rows()"
      [style.min-width]="minWidth()"
      [style.max-width]="maxWidth()"
      [style.resize]="resizable() ? 'auto' : 'none'"
      (input)="onValueChange($event)"
      (blur)="onTouched()"
    ></textarea>
  </span>
</label>
